// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"05537e12","676":"bc74e280","962":"cdbb36fb"}[chunkId] + ".chunk.js";
};